import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">关于神马视频免费在线观看的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {faqData.map((faq) => (
            <div key={faq.id} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
              <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900 mb-3 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}